export default "/images/vendor/flag-icons/flags/4x3/dk.svg?025c12105396b6e6b3b8ecf1ba953b26";